
import React, { useState ,useEffect} from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faUser,faEye,faEyeSlash, faBuilding } from '@fortawesome/free-solid-svg-icons';
/* import logoImage from "/BB.png"; */
import { useNavigate } from 'react-router-dom';
import LoginSuccessModal from './LoginSuccess';
import {requestPermission} from '../../push-notifications'
import { updateUserInServiceWorker } from '../../utils/serviceWorkerUtils';
import { encryptData } from "../../utils/storageCrypto";

function Login() {
    const [Username, setUsername] = useState('');
    const [Password, setPassword] = useState('');
    const navigate = useNavigate();
    const [InvalideEmail,setInvalidEmail]=useState(false);
    const [invalidPassword, setInvalidPassword] = useState(false);
    const [EmptyLoginData, setEmptyLoginData]= useState(false);
    const [UserNotFound,setUserNotFound]=useState(false);
    const [showPassword, setShowPassword] = useState(false);
    const [showForceLoginModal, setShowForceLoginModal] = useState(false);
    const [pendingLoginData, setPendingLoginData] = useState(null);
  
//     useEffect(() => {
//   console.log("✅ Login mounted");

//   return () => {
//     console.log("❌ Login unmounted");
//   };
// }, []);

useEffect(() => {
  const token = sessionStorage.getItem("token");

  if (token) {
    navigate("/admin/app/home", { replace: true });
  }
}, []);
  
    const handleUsernameChange = (e) => {
      setUsername(e.target.value);
      setInvalidEmail(false); // Reset invalide password state when password changes 
        setEmptyLoginData(false); // Reset Empty login data state when password changes
        setUserNotFound(false);
    };
  
    const handlePasswordChange = (e) => {
      setPassword(e.target.value);
      setInvalidPassword(false); // Reset invalide password state when password changes 
        setEmptyLoginData(false); // Reset Empty login data state when password changes
        setUserNotFound(false);
    };
  
    const validateEmail = (email) => {
      const emailValidation = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      return emailValidation.test(email);
    };
    const handlePasswordFieldFocus = () => {
      if (validateEmail(Username)) {
      }
    };
    
  
    // Password validation logic
    const validatePassword = (password) => {
      const passwordValidation = /^(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/;
      return passwordValidation.test(password);
    };
   const [LoginNavigation , setLoginNavigation]= useState()
   const [showSuccessModal, setShowSuccessModal] = useState(false);
   const [loginDetails, setLoginDetails] = useState(null);
   const [OrganisationError , setOrganisationError] = useState('')

    const handleLogin = async (forceLoginFlag = false) => {
         if (typeof forceLoginFlag !== 'boolean') {
            forceLoginFlag = false;
          }
      const LoginUrl= process.env.REACT_APP_FORE_APILINK + '/user/user-login';
      console.log(LoginUrl);
      if (!Username || !Password) {
        setEmptyLoginData("Please enter Email and Password.");//Error meassage display when inputfield are in empty state
          return;
        }  
        //validation of email and password function are get called 
        else if (!validateEmail(Username) || !validatePassword(Password)) {
          // Set the appropriate error states
          setInvalidEmail(!validateEmail(Username));
          setInvalidPassword(!validatePassword(Password));
          return;
        } 
        else{
          try {
           const LoginData= {
            username:Username,
            password:Password,
            //hubId: selectedHub,
            forceLogin: forceLoginFlag
           }
           console.log(LoginData);
            //  await new Promise(resolve => setTimeout(resolve, 2000));

            const response = await fetch(LoginUrl, {
              method: 'POST',
              headers: {
            'Content-Type': 'application/json',
              },
              body: JSON.stringify(LoginData),
            });

            const data = await response.json();
            console.log("data:",data)

            // 🔥 HANDLE FORCE LOGIN CASE
            if (response.status === 409 && data.requireConfirmation) {
              setPendingLoginData(LoginData);
              setShowForceLoginModal(true);
              return;
            }

        if(response.ok){
          console.log(response);
              localStorage.setItem('LoginData',encryptData(JSON.stringify(data)))
              sessionStorage.setItem('userData', encryptData(JSON.stringify(data)));
              sessionStorage.setItem('userId',encryptData(data.userId));
              sessionStorage.setItem('token',encryptData(data.token)); 
              sessionStorage.setItem('roleId',encryptData(data.roleID));     
              sessionStorage.setItem('roleName',encryptData(data.roleName));      
              localStorage.setItem('userId',encryptData(data.userId));
              sessionStorage.setItem('hubId',encryptData(data.hubId));
              sessionStorage.setItem('hubName',encryptData(data.hubName));
              sessionStorage.setItem('hubNumber',encryptData(data.hubNumber));
              sessionStorage.getItem('hubCity',encryptData(data.hubCity));


              requestPermission()

              const userId = data._id;
              // Update IndexedDB via service worker
              updateUserInServiceWorker(userId);

              let navigationPath = ''
              if (data.forcePasswordChange===true) {
                navigationPath = '/admin/reset-password'
                //setLoginNavigation(navigate('/admin/reset-password', { state: { LoginData: data } }))//Navigate to ResetPassword page 
              }
              //If he alredy reset the password it check the role of the use he is an admin are user
              else if (data.roleID === 0) {
                navigationPath = '/admin/app/home';
                //setLoginNavigation(navigate('/admin/app/home', { state: { LoginData: data } }))  // if he is admin navigate to AdminDashbordPage
              } else if(data.roleID === 1) {
                 navigationPath = '/admin/app/home'
                //setLoginNavigation(navigate('/admin/app/home', { state: { LoginData: data } }))//if he is user navigate to UserHomePage
              }
              else if(data.roleID === 2) {
                 navigationPath = '/admin/app/home'
                //setLoginNavigation( navigate('/admin/app/home', { state: { LoginData: data } }))//if he is user navigate to UserHomePage
              }
              else if(data.roleID === 3) {
                 navigationPath = '/admin/app/home'
                //setLoginNavigation(navigate('/admin/app/home', { state: { LoginData: data } }))//if he is user navigate to UserHomePage
              }
              else if(data.roleID === 4) {
                 navigationPath = '/admin/app/home'
                //setLoginNavigation(navigate('/admin/app/home', { state: { LoginData: data } }))//if he is user navigate to UserHomePage
              }
              else if(data.roleID === 6) {
                 navigationPath = '/admin/app/home'
                //setLoginNavigation(navigate('/admin/app/home', { state: { LoginData: data } })) ;//if he is user navigate to UserHomePage
              }
              // setLoginNavigation(() => () => navigate(navigationPath, { state: { LoginData: data } }));
              setLoginNavigation(() => () => navigate(navigationPath, { replace: true, state: { LoginData: data } }));
              setLoginDetails(data);
              setShowSuccessModal(true);
            } else {
              console.error('Login failed',response);
              setUserNotFound('Invalid Credentials')
            }
          } catch (error) {
            console.error('Error:', error);
          }
        }
    };

    const handleContinue = () => {
      setShowSuccessModal(false);
        if (LoginNavigation) {
           LoginNavigation?.();
        }
    };

    const handleForceLoginConfirm = () => {
      setShowForceLoginModal(false);
      handleLogin(true); // 🔥 call again with forceLogin = true
    };

    const handleForceLoginCancel = () => {
      setShowForceLoginModal(false);
    };
    
    // useEffect(() => {
    //   const loginData = JSON.parse(localStorage.getItem('LoginData'));
    //   if (loginData) {
    //     localStorage.setItem('LoginData', JSON.stringify(loginData));
    //     sessionStorage.setItem('userData', JSON.stringify(loginData));
    //     sessionStorage.setItem('userId', loginData.userId);
    //     sessionStorage.setItem('token', loginData.token);
     
    
    //     if (loginData.forcePasswordChange === true) {
       
    //       navigate('/ResetPassword', { state: { LoginData: loginData } }); // Navigate to ResetPassword page
    //     } else if (loginData.roleID === 0) {
    //       //setrole(loginData.roleID);
    //       navigate('/admin/app/home', { state: { LoginData: loginData } }); // Navigate to AdminDashboardPage for admin
    //     } else if (loginData.roleID === 2) {
    //       /* setrole(loginData.roleID); */
    //       navigate('/admin/app/home', { state: { LoginData: loginData } }); // Navigate to UserHomePage for user
    //     }
    //   } else {
        
    //    // setUserNotFound('User not found');
    //   }
    // }, []);
  
    useEffect(() => {
      // Don't auto-redirect based on localStorage
      // Instead, let the user log in manually
      
      // Clear any existing tokens to ensure fresh login
      localStorage.removeItem('LoginData');
      sessionStorage.removeItem('userData');
      sessionStorage.removeItem('token');
      sessionStorage.removeItem('userId');
      sessionStorage.removeItem('appId');
      sessionStorage.removeItem('hubId');
      sessionStorage.removeItem('roleId');
      sessionStorage.removeItem('roleName');
    }, []);
    

    const handleForgotPassword = () => {
      navigate('/admin/forgot-password');
    };
  
    const togglePasswordVisibility = () => {
      setShowPassword((prev) => !prev);
    };

    
    


    return (
      
      <div className="w-full flex justify-center items-center h-screen font-roboto overflow-hidden relative">
       {/* <div className={`absolute inset-0 z-10 flex justify-center items-center h-screen font-roboto overflow-hidden transition-all duration-300 ${showSuccessModal ? 'opacity-0 pointer-events-none' : 'opacity-100'}`}> */}
       {!showSuccessModal && (
  <div className="absolute inset-0 z-10 flex justify-center items-center h-screen font-roboto overflow-hidden">
                <div className="flex flex-col space-y-4 justify-center w-full items-center">
                <div className='flex flex-row justify-center items-center' >
{/*                 <img src={'/BB.png'} alt="Logo" className='h-16 w-16 sm:w-14 sm:h-14'/>
                <p className='text-4xl sm:text-2xl md:text-4xl lg:text-5xl'>BRICKBUCKET</p> */}
            </div>
                    <div className="flex-col w-1/2 sm:w-5/6 md:w-2/3 lg:w-1/2 xl:w-1/3 flex self-center items-center border border-[#D9D9D9] border-2 bg-opacity-[15%] rounded-sm p-4 sm:p-0">
                        <img src={'/logo_v.png'} alt="Logo" className='mt-5 w-25 h-20'/>
                        {/* <p className="text-2xl pt-4">LOGIN</p> */}
                        <div className="p-6 sm:px-0 relative">
                            <div className="flex-col w-full">
                            <div className='flex justify-center'>
                                {/* <p className="text-md">User Name</p> */}
                                </div>
                                <div className="flex-row flex items-center justify-center space-x-2 pl-2 pr-2 w-full relative">
                                    <span className="flex justify-center items-center absolute left-5">
                                        <FontAwesomeIcon icon={faUser} className="text-gray-400" />
                                        <div className="ml-1 mr-4  flex-grow border-r border-gray-300 h-6"></div>
                                    </span>
                                    <input
                                    type="text"
                                    placeholder="Username"
                                        className="w-5/6 sm:w-full md:w-full rounded-sm focus:outline-none focus:ring-[1px]  focus:ring-[#EB001B] text-gray-600 text-sm px-2 py-1 pr-2 pl-8 text-[12px] placeholder-text-xs border border-gray-300"
                                        value={Username}
                                      onChange={handleUsernameChange}
                                      onKeyDown={(e) => {
                                        if (e.key === 'Enter') {
                                          e.preventDefault();
                                          const passwordInput = document.querySelector('input[type="password"]');
                                          if (passwordInput) {
                                            passwordInput.focus();
                                          }
                                        }
                                      }}
                                     
                                   />
                                    {InvalideEmail && (
                                    <div className="text-red-500 text-[12px]">
                                        <p className="flex justify-center">Enter the correct Email</p>
                                    </div>
                                    )}
                                    </div>
                                                                </div>
                                <div className='flex flex-col p-2 sm:p-0 sm:mt-4'>
                                    <div className='flex justify-center'>
                                {/* <p className="text-md">Password</p> */}
                                </div>
                                <div className="flex-row flex items-center space-x-2 relative justify-center pl-2 pr-2 w-full">
                                    <span className="flex justify-center items-center absolute left-5">
                                        <FontAwesomeIcon icon={showPassword ? faEyeSlash : faEye} className="text-gray-400 cursor-pointer" onClick={togglePasswordVisibility} />
                                        <div className="ml-1 mr-4 flex-grow border-r border-gray-300 h-6"></div>
                                    </span>
                                    <input
                                    onChange={handlePasswordChange}
                                    onFocus={handlePasswordFieldFocus}
                                     type={showPassword ? "text" : "password"}
                                     placeholder="Password"
                                     value={Password}
                                    className="w-5/6 sm:w-full md:w-full rounded-sm focus:outline-none focus:ring-[1px]  focus:ring-[#EB001B]  text-gray-600 text-sm px-2 py-1 pr-2 pl-8 text-[12px] placeholder-text-xs border border-gray-300"
                                    onKeyDown={(e) => {
                                      if (e.key === 'Enter') {
                                        e.preventDefault();
                                        handleLogin(); // Call the handleLogin function when Enter key is pressed
                                      }
                                    }}
                                     />
                                    {invalidPassword && (
                                        <div className="text-red-500 text-[12px]">
                                            <p>Password is incorrect</p>
                                        </div>
                                        )}
                                </div>
                                {(EmptyLoginData || UserNotFound) && (
                                <div className="text-red-500 text-[12px] flex justify-center items-center">
                                <p className="text-red-500">
                                    {EmptyLoginData || UserNotFound}
                                </p>
                                </div>
                            )}
                            </div>



                            
                            <div className="flex justify-center items-center mt-3">
                                <p className="underline text-[#2158E5] hover:text-[#EB001B] cursor-pointer text-[14px]" onClick={handleForgotPassword}>Forgot Password?</p>
                            </div>
                            <div className="flex justify-center items-center mt-3">
                                <button className="border border-[#EB001B] hover:bg-[#EB001B] hover:text-white text-md rounded-sm px-4 py-1  mb-4"
                                onClick={() => handleLogin()}>Login</button>
                            </div>


                            
                        </div>
                    </div>
                </div>
            </div>
       )}

            {showSuccessModal && loginDetails &&(
        <LoginSuccessModal 
          userName={loginDetails.username}
          onClose={handleContinue}
        />
      )}

      {showForceLoginModal && (
      <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-40 z-50">
        <div className="bg-white rounded-lg shadow-lg p-6 w-[300px] text-center">
          
          <h2 className="text-lg font-semibold mb-3 text-gray-800">
            Active Session Found
          </h2>

          <p className="text-sm text-gray-600 mb-5">
            You are already logged in on another device. Do you want to logout from other devices and continue?
          </p>

          <div className="flex justify-center gap-4">
            <button
              onClick={handleForceLoginCancel}
              className="px-4 py-1 border border-gray-400 rounded hover:bg-gray-200"
            >
              Cancel
            </button>

            <button
              onClick={handleForceLoginConfirm}
              className="px-4 py-1 bg-[#EB001B] text-white rounded hover:bg-red-600"
            >
              OK
            </button>
          </div>
        </div>
      </div>
    )}
        </div>
    );
}

export default Login;
